
/**
 * 강의 난이도
 */
export type GetRoadmapDetail200CoursesItemLevel = typeof GetRoadmapDetail200CoursesItemLevel[keyof typeof GetRoadmapDetail200CoursesItemLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRoadmapDetail200CoursesItemLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
